// extracted by css-extract-rspack-plugin
export default {"Wrapper":"wizard-header_Wrapper__q-JN8","Title":"wizard-header_Title__V93+o","ButtonsWrapper":"wizard-header_ButtonsWrapper__m6AvG"};